import { LoadingOutlined } from '@ant-design/icons';
import { Space, Spin } from 'antd';
import React, { useState } from 'react';

import StickyPageHeader from '../components/common/StickyPageHeader';
import ContactsTable from '../components/tables/ContactsTable';
import { useContacts } from '../hooks/apiHooks';
import Layout from '../layout';
import ContactPage from './ContactPage';

const ContactsPage = ({ routes }) => {
  const { allContacts, isLoading } = useContacts();
  const [currentContactId, setCurrentContactId] = useState(0);

  const _contactSelected = (contactId) => {
    setCurrentContactId(contactId);
  };

  const _contactDeselected = () => {
    setCurrentContactId(0);
  };

  return (
    <Layout
      disableLoading
      menuIndex={0}
      routes={routes}
      showCarriersNavigation={false}
    >
      {currentContactId > 0 ? (
        <>
          <StickyPageHeader isAdmin title="Contact Details" />
          <ContactPage
            contactId={currentContactId}
            goBack={_contactDeselected}
          />
        </>
      ) : (
        <>
          <StickyPageHeader isAdmin title="Contacts" />
          {isLoading ? (
            <div style={{ height: '100%', textAlign: 'center' }}>
              <Spin indicator={<LoadingOutlined spin style={{ fontSize: 20 }} />} />
            </div>
          ) : (
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
              <ContactsTable
                contacts={allContacts}
                loading={isLoading}
                onContactSelect={_contactSelected}
              />
              <p style={{ textAlign: 'right' }}>{allContacts.length} contacts</p>
            </Space>
          )}
        </>
      )}
    </Layout>
  );
};

export default ContactsPage;
